<template>
	<div class="upRightB ">
		<div class="itemTitleBox disStart">
			<span class="title">充值优惠</span>
		</div>
		<div class="listBox disCenter">
			<div class="picBox disStart">
				<div class="picL boxShaw disCenter">
					<div v-if="obj.imgobj6.pictureUrl" class="imgBox">
						<img :src="$basImgUrl+obj.imgobj6.pictureUrl" class="avatar">
						<span class="delIcon" @click.stop="delImg(obj.imgobj6,6)"></span>
					</div>
					<el-upload v-else class="itemBox avatar-uploader disCenter" :data="{pictureType: 6,pictureIndex: 1}"
						:headers="headers" :action="$upUrl+'/projectAdvertisement/addProjectAdvertisement'"
						:show-file-list="false" :on-success="handleAvatarSuccess6">
						+优惠图标
					</el-upload>
				</div>
			</div>
		</div>

	</div>
</template>
<script type="text/javascript">
	import ajax,{upLoadimg} from '../../../../../common/js/ajax.js'
	var token = localStorage.getItem('token')
	export default {
		name: "upRightB",
		data() {
			return {
				headers: {
					Authorization: token,
					token: token
				},
				url:upLoadimg,
				obj: {
					imgobj6: {
						advertisementId: "",
						pictureIndex: 1,
						pictureUrl: ""
					},
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getlistProjectAdvertisementByPictureType(6)
			})
		},
		methods: {
			delImg(item, n) {
				this.$api.deleteProjectAdvertisement({
					advertisementId: item.advertisementId
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n ==6) {
							this.$set(this.obj, "imgobj6", {
								advertisementId: "",
								pictureIndex: 1,
								pictureUrl: ""
							})
						}
					}
				})
			},
			getData() {},
			handleAvatarSuccess6(res, file, fileList) {
				this.getlistProjectAdvertisementByPictureType(6)
			},
			// 获取首页banner图
			getlistProjectAdvertisementByPictureType(n) {
				this.$api.listProjectAdvertisementByPictureType({
					pictureType: n
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n == 6) {
							this.$set(this.obj, "imgobj6", res.obj[0] || {})
						}
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./upRightB.scss";
</style>
